import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../abilities/Can';
import { isCollectionDetailView, isModule, isView } from '../../../helpers/windowLocation';

export const useCanUseAiFeatures = (hasNLSOnDashboardSplit: boolean) => {
	const ability = useAbility(AbilityContext);
	const isSimilaritySearchECA = ability.can('show', 'ai_similarity_search');

	const isSimilaritySearchSupportedModule = isModule('media') || isCollectionDetailView();
	const canUseSimilaritySearch = isSimilaritySearchECA && isSimilaritySearchSupportedModule;

	const isNLSSupportedModule =
		isModule('media') ||
		isCollectionDetailView() ||
		(isView('dashboard') && hasNLSOnDashboardSplit);

	const canUseNLSSearch = isSimilaritySearchECA && isNLSSupportedModule;

	return { canUseSimilaritySearch, canUseNLSSearch };
};
